import { AbstractControl, ValidatorFn } from '@angular/forms';

export const GUID_TO_UUID_REGEX = /^([a-f0-9]{8})([a-f0-9]{4})([a-f0-9]{4})([a-f0-9]{4})([a-f0-9]{12})$/i;

export const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/;

export function uuidValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const value = control.value;

    // If the value is null or empty, don't validate here (the 'required' validator handles this)
    if (value === null || value === undefined || value === '') {
      return null;
    }

    // If it's not a string, it's an incorrect type
    if (typeof value !== 'string') {
      return { 'uuidInvalidFormat': { value: value } };
    }

    // Validate with the regular expression
    const isValid = UUID_REGEX.test(value);
    return isValid ? null : { 'uuidInvalidFormat': { value: value } };
  };
}
